export default __webpack_public_path__ + "static/media/structalyse.df00e269.md";